<template>
<div class="dashboard">
    <b-container :fluid="dashboardType=='results'">
        <CurrentPhase class="currentPhase" v-if="dashboardType=='players'" :dayNum="store.currentDay" :dayStage="store.dayStage"/>

        <!-- TODO refactor as it is copy past from CurrentDay -->
        <b-row v-if="store.dayStage === 'Supplier' && dashboardType=='players'">
            <b-col class="mt-4">
                <strong>Manufacturing phase</strong>
                <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#d6edfc" d="M13.3 7.7L0 0v15.3z"/></svg>
                <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#EC008C" d="M13.3 7.7L0 0v15.3z"/></svg>
                <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#d6edfc" d="M13.3 7.7L0 0v15.3z"/></svg>
                <p>Tip: Produce as soon as possible</p>
            </b-col>
        </b-row>
        <b-row  v-if="dashboardType=='players'">
            <b-col>
                <img v-if="store.dayStage === 'Supplier'" class="deco" src="@/assets/pods.svg">
                <img v-if="store.dayStage === 'Customer'" class="deco" src="@/assets/Asset-52.png">
            </b-col>
        </b-row>

        <b-row v-if="dashboardType=='ranking'" align-v="center" class="text-center">
            <b-col>
                <h1>Day {{store.currentDay}}</h1>
            </b-col>
            <b-col>
                <h2>Ranking</h2>
            </b-col>
            <b-table class="table-large" striped hover :items="ranking" :fields="fields"></b-table>
        </b-row>
        <b-row v-if="dashboardType=='results'" align-v="center" class="text-center">
            <b-col>
                <h1>Day {{store.currentDay}}</h1>
            </b-col>
            <b-col>
                <export-excel :data="results" name="results.xls" title="Aroolla Game: Roasteria Mano" worksheet="roasteria-mano-results">
                    <b-button variant="outline-primary" size="lg">EXPORT</b-button>
                </export-excel>
            </b-col>
        </b-row>
        <b-row v-if="dashboardType=='results'">
            <b-col class="table-overflow">
                <b-table class="table-results table-large" striped hover :items="results" :fields="fieldsResults">
                    <template slot="team" slot-scope="row">
                        <b-button  variant="outline-primary" size="sm" @click="row.toggleDetails">
                            <span v-if="row.item.errors.length > 0">⚠️</span>{{row.item.team}}
                        </b-button>
                    </template>

                    <template slot="row-details" slot-scope="row">
                        <b-card>
                        <b-row class="mb-2">
                            <b-col class="text-sm-left"><b>Errors:</b>
                                <ul>
                                    <li v-for="(err, idx) in row.item.errors" v-bind:key="idx">{{ err }}</li>
                                </ul>
                            </b-col>

                        </b-row>
                        </b-card>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
    import CurrentPhase from '@/components/CurrentPhase';
    export default {
        name: "Dashboard",
        components: {CurrentPhase},
        data(){
            return {
                fieldsResults: [
                    'team', 'cash', 'receivable', 'finishedStockValue', 'coffeeStock', 'podStockValue', 'turnover', 'cogs', 'result',
                    'podStockQty',  'producedQty', 'salesQty', 'avgProductionCost'
                ].map(f => ({key: f, sortable: true}))
            };
        },
        computed: {
            store() {
                return this.$root.$data.store;
            },
            fields() {
                return [
                    {
                        key: 'rank',
                        sortable: true
                    },
                    {
                        key: 'team',
                        sortable: true
                    },
                    {
                        key: 'net_income',
                        sortable: true,
                        formatter: 'dollar'
                    }
                ];
            },
            days() {
                return this.store.days;
            },
            dashboardType() {
                return this.$route.params.type ? this.$route.params.type : 'players';
            },
            ranking() {
            let ranking = Array(this.store.nboTeams);
            let results = this.results;
            for (let t = 0; t < ranking.length; t++) {
                ranking[t] = {rank: 0, team: t + 1, net_income:results[t]['result'] }
            }
            ranking.sort(function(a, b) { return b.net_income - a.net_income ; });
            for (let index = 0; index < ranking.length; index++) {
                ranking[index]['rank'] = index + 1;
            }
            return ranking; //rankingDisplay;
        },
            results() {
                let _results = Array(this.store.nboTeams);
                let _fifo = Array(this.$root.$data.store.nboTeams);
                let days = this.days;
                const maxProductionQty = 3;
                const coffeeCostPerPod = 3;
                const podsPerLot = 4;
                const podInitialUnitCost = 1;
                const cashInitial = 20;
                const coffeeStockInitial = 250;
                const podStockInitial = 10;
                const podStockValueInitial = podStockInitial * podInitialUnitCost;

                for (let t = 0; t < _results.length; t++) {
                    // initial balance sheet
                    _results[t] = {
                        team: t+1, cash: cashInitial, receivable: 0, podStockQty: podStockInitial, coffeeStock: coffeeStockInitial,
                        capital: cashInitial + coffeeStockInitial + podStockValueInitial,
                        podStockValue: podStockValueInitial,
                        salesQty: 0, turnover:0, cogs:0, result: 0,
                        errors: []
                    };

                    if(this.store.days.length === 0) return;

                    _fifo[t] = {inventory: [{qty: 10, pu: 1}]};

                    // dayIndex balance sheet
                    for (let d = 0; d < this.store.currentDay; d++) {
                        //purchases
                        if (d > 0) {
                            _fifo[t].inventory.push(
                                {
                                    qty: days[d - 1].purchase[t].qty,
                                    pu: days[d - 1].supplierPrice
                                }
                            )
                            let dayPurchase = days[d - 1].supplierPrice * Number(days[d - 1].purchase[t].qty)
                            if (days[d - 1].purchase[t].paid)
                                _results[t].cash -= dayPurchase;
                                if (dayPurchase > 0 && _results[t].cash < 0) {
                                    _results[t].errors.push(`invalid purchase team ${t + 1} day ${d + 1} missing cash ${ _results[t].cash}`);
                                }
                            _results[t].podStockQty += days[d - 1].purchase[t].qty;
                        }

                        //sales
                        let daySaleQty = Number(days[d].sales[t].qty);
                        let daySale = days[d].customerPrice * daySaleQty;
                        _results[t].podStockQty -= podsPerLot * daySaleQty;
                        _results[t].coffeeStock -= coffeeCostPerPod * podsPerLot * daySaleQty;
                        _results[t].salesQty += daySaleQty;
                        let podSaleQty = daySaleQty * podsPerLot;
                        let consumedQty = 0;
                        while (podSaleQty > 0) {
                            if(_fifo[t].inventory.length === 0) {
                                _results[t].errors.push(`invalid inventory team ${t + 1} day ${d + 1} missing pods ${podSaleQty}`);
                                break;
                            }
                            if (_fifo[t].inventory[0].qty > podSaleQty) {
                                consumedQty = podSaleQty;
                                _fifo[t].inventory[0].qty -= consumedQty;
                                _results[t].cogs += consumedQty * (coffeeCostPerPod + _fifo[t].inventory[0].pu);
                            } else {
                                consumedQty = _fifo[t].inventory[0].qty;
                                _results[t].cogs += consumedQty * (coffeeCostPerPod + _fifo[t].inventory[0].pu);
                                //first entry consumed suppressed it
                                _fifo[t].inventory.shift();
                            }
                            podSaleQty -= consumedQty;
                        }

                        _results[t].turnover += daySale;
                        if (days[d].sales[t].paid) {
                            _results[t].cash += daySale;
                        } else {
                            _results[t].receivable += daySale;
                        }
                    }
                    _results[t].result = _results[t].turnover - _results[t].cogs;

                    // convert stocks to finished products
                    _results[t].finishedStockValue = 0;
                    _results[t].producedQty = 0;
                    while(_results[t].podStockQty >= podsPerLot && _results[t].coffeeStock >= coffeeCostPerPod * podsPerLot && _results[t].producedQty < maxProductionQty) {
                        let podSaleQty = podsPerLot;
                        let consumedQty = 0;
                        while (podSaleQty > 0) {
                            if (_fifo[t].inventory[0].qty > podSaleQty) {
                                consumedQty = podSaleQty;
                                _fifo[t].inventory[0].qty -= consumedQty;
                                _results[t].finishedStockValue += consumedQty * (coffeeCostPerPod + _fifo[t].inventory[0].pu);
                            } else {
                                consumedQty = _fifo[t].inventory[0].qty;
                                _results[t].finishedStockValue += consumedQty * (coffeeCostPerPod + _fifo[t].inventory[0].pu);
                                //first entry consumed suppressed it
                                _fifo[t].inventory.shift();
                            }
                            podSaleQty -= consumedQty;
                        }
                        _results[t].podStockQty -= podsPerLot;
                        _results[t].coffeeStock -= coffeeCostPerPod * podsPerLot;
                        _results[t].producedQty += 1;
                    }
                    _results[t].podStockValue = _fifo[t].inventory.reduce((total, i) => total + (i.qty * i.pu), 0);
                    _results[t].producedQty += _results[t].salesQty;
                    _results[t].avgProductionCost = Math.round((_results[t].cogs + _results[t].finishedStockValue) / _results[t].producedQty*100)/100;
                }
                return _results;
            }
        },
        methods: {
                dollar(value) {
                    let absValue = Math.abs(value);
                    return  value<0 ? "-$": "$" + Math.round(absValue * Math.pow(10, 2)) / Math.pow(10, 2);
                }
            },
        watch: {
            '$root.store.dayStage': {
                handler() {
                    if(this.dashboardType === 'players' && this.$root.store.dayStage === 'Ranking') {
                        this.$router.push({name: 'dashboard', params: {type: 'ranking'}})
                    }
                }
            }
        }
    }
</script>
<style>
    .dashboard .currentPhase h2.price{
        font-size: 60px;
        margin: 20px 0;
    }
    .table-results td {
        text-align: right;
    }
</style>
<style scoped>
    .chevron {
        padding: 0 1px;
        height: 18px;
    }

    .deco {
        opacity: 0.4;
        width: 80%;
        max-width: 300px;
        display: block;
        margin: 40px auto;
    }
    .table-large {
        font-size: 1.6em;
    }
    .table-overflow {
        overflow: auto;
    }
</style>
